var SPINNER_SIZES = ['sm', 'md', 'lg', 'xl', 'xxl'];

export { SPINNER_SIZES };
